import { css } from 'styled-components';
import makeThemedComponent from '../../utils/makeThemedComponent';
var defaultStyles = css(["cursor:pointer;padding:0.25rem;user-select:none;"]);
/**
 * Renders an `li` element mean to be used in the `DropdownMenu` component.
 *
 * @public
 * @author Connor Taylor
 */

var DropdownItem = makeThemedComponent({
  component: "li",
  themeKey: "DropdownItem",
  defaultStyles: defaultStyles
});
export { defaultStyles };
/** @component */

export default DropdownItem;